<div [ngClass]="
     {
     '!h-[276px]' : temporaryState() === 'account-list',
     '!h-[516px]' : temporaryState() === 'add-business-account',
     'touch-scrolled': touchScrolled()
     }" class="dialog-switch-account overflow-y-auto thin-scrollbar h-full max-h-[98%]"
     (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove()" (touchend)="onTouchEnd()">

  @if(temporaryState() === 'account-list'){
    <div class="thin-scrollbar overflow-y-auto grow shrink-0">
      <div class="flex flex-col
        [&>div]:border-b [&>div]:border-solid [&>div]:border-[#D9E3E5]
        first:[&>div]:rounded-t-[8px]">
        @for (account of authService.accounts(); track account.uuid) {
        <div (click)="changeAccount(account.uuid)"
          [attr.data-row-id]="account.uuid"
          [ngClass]="{
            'bg-[#F2F4F5] pointer-events-none': account.uuid === authService.accountDto()?.uuid,
            'tap-highlight': tapHighlightRowId() === account.uuid
          }"
          class="switch-account-row min-h-[46px] hover:bg-[#F2F4F5] flex items-center py-[5px] pl-[6px] pr-[8px] grow shrink-0 cursor-pointer"
          tabindex="0">
          <div class="flex items-center w-full max-w-[calc(100%-24px)]">
            @if (account.accountType === 'PERSONAL') {
            <div class="min-w-[34px] w-[34px] h-[34px] rounded-[50%] flex flex-col items-center justify-center">
              <img src="assets/img/profile-placeholder.png" alt="user-photo" class="w-[34px] h-[34px] object-cover">
            </div>
            } @else {
            <div class="min-w-[34px] w-[34px] h-[34px] rounded-[50%] flex flex-col items-center justify-center">
              <img src="assets/img/profile-placeholder-2.svg" alt="user-photo" class="w-[20px] h-[17px] object-cover">
            </div>
            }
            <div class="flex flex-col ml-2 overflow-hidden">
              <span class="text-[12px] leading-[1.3] text-[#323142] whitespace-nowrap text-ellipsis overflow-hidden">
                @switch (account.accountType) {
                  @case ('PERSONAL') {
                    {{ account.user.fullName || '---' }}
                  }
                  @case ('CORPORATE') {
                    {{ account.companyDto?.name || '---' }}
                  }
                  }
              </span>
              <div class="flex items-center mt-[2px]">
                <mat-icon svgIcon="icon-profile" class="text-[#778F8F] max-w-[7px] max-h-[9px]"></mat-icon>
                @if (account.accountType === 'PERSONAL') {
                <span class="text-[#778F8F] text-[12px] ml-[5px]">
                  Personal account
                </span>
                } @else {
                <span class="text-[#778F8F] text-[12px] ml-[5px]">
                  {{account.companyRole}}
                </span>
                }
              </div>
            </div>
          </div>
          <div
            class="grow shrink-0 max-w-[24px] max-h-[24px] w-[24px] h-[24px] rounded-[50%] flex flex-col items-center justify-center border border-solid border-[#323142]/30 bg-white">
            <span [ngClass]="{ '!bg-[#323142]' : account.uuid === authService.accountDto()?.uuid}"
              class="w-[12px] h-[12px] bg-white rounded-[50%]">
            </span>
          </div>
        </div>
        }
      </div>
      <div
        (click)="temporaryState.set('add-business-account')"
        data-row-id="add-business"
        [ngClass]="{ 'tap-highlight': tapHighlightRowId() === 'add-business' }"
        class="switch-account-row min-h-[46px] hover:bg-[#F2F4F5] flex items-center py-[5px] pl-[6px] pr-[8px] grow shrink-0 cursor-pointer gap-2"
        tabindex="0">
        <div
          class="flex flex-col items-center justify-center max-w-[34px] max-h-[34px] w-[34px] h-[34px] rounded-[50%] grow shrink-0 bg-[#778F8F]/10">
          <mat-icon svgIcon="vector-plus" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#778F8F]"></mat-icon>
        </div>
        <span class="text-[14px] text-[#778F8F]">
          Add Business account
        </span>
      </div>
    </div>
  } @else {
    <app-benefit-business-account></app-benefit-business-account>
  }
</div>
